import * as React from 'react';

const SvgAdditionalMini = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M27.333 22.333h-3v-3c0-.546-.453-1-1-1-.547 0-1 .454-1 1v3h-3c-.547 0-1 .454-1 1 0 .547.453 1 1 1h3v3c0 .547.453 1 1 1 .547 0 1-.453 1-1v-3h3c.547 0 1-.453 1-1 0-.546-.453-1-1-1ZM29.333 11.36V5.307c0-1.88-.853-2.64-2.973-2.64h-5.387c-2.12 0-2.973.76-2.973 2.64v6.04c0 1.893.853 2.64 2.973 2.64h5.387c2.12.013 2.973-.747 2.973-2.627ZM14 11.36V5.307c0-1.88-.853-2.64-2.973-2.64H5.64c-2.12 0-2.973.76-2.973 2.64v6.04c0 1.893.853 2.64 2.973 2.64h5.387C13.147 14 14 13.24 14 11.36ZM14 26.36v-5.387c0-2.12-.853-2.973-2.973-2.973H5.64c-2.12 0-2.973.853-2.973 2.973v5.387c0 2.12.853 2.973 2.973 2.973h5.387c2.12 0 2.973-.853 2.973-2.973Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgAdditionalMini;
